import React, { useEffect, useMemo, useState } from 'react';
import { Field } from 'redux-form';

import { TextInput, Modal } from '../../_Components';
import { UPDATE, GET_ONE, GET_LIST, provider } from '../../_utils';
import {
    ColumnPicker,
    ReportSettingsFields,
    mergeReportFields,
} from './reportSettingsUi';
import '../../projects/Edit/reports.css';
import '../reports.css';

const SettingsForm = ({
    queuesList = [],
    fields = [],
    formValues,
    change,
}) => {
    const [tab, setTab] = useState('settings');
    const report = formValues || {};
    const screenCount = report.report && Array.isArray(report.report.report) ? report.report.report.length : 0;
    const xlsCount = report.report && Array.isArray(report.report.xls) ? report.report.xls.length : 0;
    const projectName = report.project && report.project.name;
    const cardName = projectName || '';

    return (
        <div className="pc-pr-modal">
            <div className="pc-pr-subtabs" role="tablist">
                <button type="button" role="tab" aria-selected={tab === 'settings'} onClick={() => setTab('settings')}>
                    Настройки
                </button>
                <button type="button" role="tab" aria-selected={tab === 'screen'} onClick={() => setTab('screen')}>
                    Отчёт на экране<span className="c">{screenCount || ''}</span>
                </button>
                <button type="button" role="tab" aria-selected={tab === 'xls'} onClick={() => setTab('xls')}>
                    Отчёт Excel<span className="c">{xlsCount || ''}</span>
                </button>
            </div>
            <div className={`pc-pr-sub${tab === 'settings' ? ' is-on' : ''}`}>
                <ReportSettingsFields
                    report={report}
                    queuesList={queuesList}
                    change={change}
                    showCampaign={false}
                    extraMain={(
                        <Field
                            name="project.name"
                            label="Проект"
                            disabled
                            component={TextInput}
                        />
                    )}
                />
            </div>
            <div className={`pc-pr-sub${tab === 'screen' ? ' is-on' : ''}`}>
                <div className="pc-pr-wrap">
                    <Field
                        name="report.report"
                        component={ColumnPicker}
                        available={fields}
                        kind="scr"
                        cardName={cardName}
                    />
                </div>
            </div>
            <div className={`pc-pr-sub${tab === 'xls' ? ' is-on' : ''}`}>
                <div className="pc-pr-wrap">
                    <Field
                        name="report.xls"
                        component={ColumnPicker}
                        available={fields}
                        kind="xls"
                        cardName={cardName}
                        onCopyFromScreen={() => change && change(
                            'report.xls',
                            (report.report && report.report.report) || []
                        )}
                    />
                </div>
            </div>
        </div>
    );
};

const SettingsModal = ({ handleCloseClick, showDialog, id }) => {
    const [settings, setSettings] = useState(null);
    const [queues, setQueues] = useState([]);

    const fields = useMemo(
        () => mergeReportFields(settings && settings.project && settings.project.fields),
        [settings]
    );

    const save = async (formValues) => {
        const { name, report, settings: nextSettings, status } = formValues;
        const response = await provider(UPDATE, '/reports', {
            id: formValues._id,
            data: { name, report, settings: nextSettings, status },
        });
        if (response.status === 200) {
            handleCloseClick(true);
        }
    };

    const close = () => {
        handleCloseClick(false);
    };

    useEffect(() => {
        const getReport = async () => {
            const { data, status } = await provider(GET_ONE, '/reports', id);
            if (status === 200) {
                setSettings(data);
            }
        };
        const getQueues = async () => {
            const { status, data } = await provider(GET_LIST, '/infra/queues', {
                filter: {},
                sort: { field: 'name', order: 'ASC' },
                pagination: { page: 1, perPage: 999 },
            });
            if (data && status === 200) {
                setQueues(data);
            }
        };
        getReport();
        getQueues();
    }, [showDialog, id]);

    if (!settings) {
        return null;
    }

    return (
        <Modal
            title="Настройки отчёта"
            width={1120}
            open={showDialog}
            handleSaveClick={save}
            handleCloseClick={close}
            initial={settings}
            fields={
                <SettingsForm
                    queuesList={queues}
                    fields={fields}
                />
            }
        />
    );
};

export default SettingsModal;
